export const ConfigurationType = {
    VENDA_INDEX: 'HABILITAR_VENDA_INDEX'
};